import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum AddEditProductPriceFormErrorStatesEnum {
    RegisterProductWithPricesFailed = ErrorStateScheduleEnum.AddEditProductPriceFormStatesStartIndex,
    UpdateProductWithPricesFailed,
    RegisterProductWithPricesFailedDuplicate,
}
